<script lang="ts">
  import FeatureReviews from "../../Logic/Web/MangroveReviews"
  import SingleReview from "./SingleReview.svelte"
  import { Utils } from "../../Utils"
  import StarsBar from "./StarsBar.svelte"
  import type { Review } from "mangrove-reviews-typescript"
  import Translations from "../i18n/Translations"
  import Tr from "../Base/Tr.svelte"
  import ReviewPrivacyShield from "./ReviewPrivacyShield.svelte"
  import ThemeViewState from "../../Models/ThemeViewState"
  import { Store, UIEventSource } from "../../Logic/UIEventSource"
  import type { Feature } from "geojson"
  import LayerConfig from "../../Models/ThemeConfig/LayerConfig"
  import Loading from "../Base/Loading.svelte"
  import { Lists } from "../../Utils/Lists"
  /**
   * An element showing all reviews
   */
  export let reviews: FeatureReviews
  export let state: ThemeViewState
  export let tags: UIEventSource<Record<string, string>> = undefined
  export let feature: Feature = undefined
  export let layer: LayerConfig = undefined
  let average = reviews.average
  let allReviews: Store<
    (Review & {
      kid: string
      signature: string
      madeByLoggedInUser: Store<boolean>
    })[]
  > = reviews.reviews.map((r) => Lists.noNull(r))
  let test = state.featureSwitches.featureSwitchIsTesting
  let debug = state.featureSwitches.featureSwitchIsDebugging
  let subject: Store<string> = reviews.subjectUri
</script>

<ReviewPrivacyShield loadingAllowed={reviews.loadingAllowed} guistate={state.guistate}>
  <div class="flex flex-col gap-y-2 border-2 border-dashed border-gray-300 p-2">
    {#if $allReviews?.length > 1}
      <StarsBar score={$average} />
    {/if}
    {#if !$allReviews}
      <div class="flex justify-center">
        <Loading />
      </div>
    {:else if $allReviews.length > 0}
      {#each $allReviews as review}
        <SingleReview {review} {state} {tags} {feature} {layer} {reviews} showMenu={false} />
      {/each}
    {:else}
      <div class="subtle m-2 flex justify-center italic">
        <Tr t={Translations.t.reviews.no_reviews_yet} />
      </div>
    {/if}
    <div class="flex justify-end">
      <a
        href={"https://mangrove.reviews" +
          ($allReviews?.length > 0 ? "/search?sub=" + encodeURIComponent($subject) : "")}
        target="_blank"
        class="subtle text-sm"
      >
        <Tr t={Translations.t.reviews.attribution} />
      </a>
    </div>
    {#if $debug || $test}
      <span class="self-end">{$subject}</span>
    {/if}
  </div>
</ReviewPrivacyShield>
